export const BLACK_LIST_REASON = [
  'Took too long to deliver',
  'Rider failed to deliver',
  'Partner has fired rider',
  'Other'
];
